import React from 'react'
import "./getintouch.css";

const Getintouch = () => {
  return (
    <>
       <div className="get-in-touch sub-section">
        <div className="container">
          <div className="container flex-container">
            <div className="contact-card flex-center">
              <div className="title">
                <h4>Let's Talk</h4>
                <h3>About My</h3>
                <h2>Next Project</h2>
              </div>
              <div className="contact-btn">
                <a href="" className="btn button-30">Get In Touch <div className="space"><i className="fas fa-paper-plane"></i></div></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Getintouch
